import React, { useState } from 'react';
import { Text } from 'library';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { styled } from '@mui/material';
import { format12HourTime, formatLongMonthDay } from 'shared/Dates';
import SectionContainer from './SectionContainer';
import EditSchedulesModal from './EditSchedulesModal';
import DayCircle from './DayCircle';

export default function JobSchedulesSection() {
    const { form } = useJobFormContext();
    const { daysOfTheWeek, startDate, endDate, breakRequired, headline, businessJobType } = form.fieldStates;
    const [editOpen, setEditOpen] = useState(false);
    const trialRun = businessJobType.value === 'TRIAL_RUN';

    function getDateText() {
        if (!startDate.value) return '';
        if (trialRun) {
            return `Starting as soon as ${formatLongMonthDay(startDate.value.toDate())}`;
        }
        let text = formatLongMonthDay(startDate.value.toDate());
        if (endDate.value && !startDate.value.isSame(endDate.value, 'day')) {
            text = `${text} - ${formatLongMonthDay(endDate.value.toDate())}`;
        }
        return text;
    }
    return (
        <SectionContainer
            editModal={
                <EditSchedulesModal open={editOpen} onClose={() => setEditOpen(false)} headline={headline.value} />
            }
            setEditOpen={setEditOpen}
        >
            <Text variant="h2" bold>
                {getDateText()}{' '}
                {breakRequired.value && (
                    <Text variant="caption" inline>
                        {' '}
                        *Break required
                    </Text>
                )}
            </Text>

            <SchedulesContainer>
                <div>
                    {Object.values(daysOfTheWeek.value)
                        .filter((x) => x.selected)
                        .map((time) => (
                            <ScheduleContainer key={time.id}>
                                <DayCircle day={time.day} />
                                <Text variant="body2">
                                    {format12HourTime(time.start)} - {format12HourTime(time.end)} ({time.slots} worker
                                    {time.slots > 1 ? 's' : ''})
                                </Text>
                            </ScheduleContainer>
                        ))}
                </div>
            </SchedulesContainer>
        </SectionContainer>
    );
}

const SchedulesContainer = styled('div')({
    gap: 4,
    marginTop: 12,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
});

const ScheduleContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    marginTop: 8,
});
